const languageByDomainDetector = require('./languageByDomainDetector')
const ignoreRoutes = require('./ignoreRoutes')
const path = require('path')
const { getSupportedLanguageCodes } = require('../utils/localization')

module.exports = {
  ignoreRoutes,
  localePath: path.resolve('./public/static/locales'),
  defaultLanguage: 'en',
  otherLanguages: getSupportedLanguageCodes(),
  load: 'currentOnly',
  customDetectors: [languageByDomainDetector],
  detection: {
    order: ['querystring', 'domain'],
    cookieSecure: true,
    cookieSameSite: 'strict',
  },
}
